import React, { useState, useEffect, useMemo } from "react";
import calendar from "../../PicesForPages/calendar-5.png";
import smartphoneHand from "../../PicesForPages/smartphone-7.png";
import smartphoneVoice from "../../PicesForPages/smartphone-6.png";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";
import ChatBotPurchase from "../Form/ChatBotPurchase";
import ChatBotRefinance from "../Form//ChatBotRefinance";
import Video_1 from "../../PicesForPages/Video_1.mov";

import { Link } from "react-router-dom";

function Home() {
  const texts = useMemo(
    () => [
      "Reduce Your Payment",
      "Secure a Better Rate",
      "Own Your First Home",
      "Get Your Dream Home",
      "Access Your Equity",
    ],
    [],
  );

  const [currentText, setCurrentText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [activeChatBot, setActiveChatBot] = useState(null); // null, "purchase", or "refinance"
  const typingSpeed = 100;
  const deletingSpeed = 50;

  useEffect(() => {
    const handleTyping = () => {
      const fullText = texts[currentTextIndex];

      if (!isDeleting) {
        setCurrentText((prev) => fullText.substring(0, prev.length + 1));
        if (currentText === fullText) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        setCurrentText((prev) => fullText.substring(0, prev.length - 1));
        if (currentText === "") {
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    };

    const typingInterval = setInterval(
      handleTyping,
      isDeleting ? deletingSpeed : typingSpeed,
    );

    return () => clearInterval(typingInterval);
  }, [currentText, isDeleting, texts, currentTextIndex]);

  return (
    <div className="homeParent">
      <div className="homeHelpYouBoxParent">
        <div className="homeHelpYouBoxVideoBox">
          <video className="homeHelpYouBoxVideo" autoPlay loop muted>
            <source src={Video_1} type="video/mp4" />
            <source src={Video_1.replace(".mp4", ".webm")} type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="homeHelpYouBox">
          {activeChatBot === null && (
            <>
              <span className="homeHelpYouHeading">
                <span className="homeHelpYouHeadingLeft">
                  Let's Assist You...{" "}
                </span>
                <span className="typingText homeHelpYouHeadingRight">
                  {currentText}
                </span>
              </span>
              <span className="homeHelpYouContent homeHelpYouContenttext">
                Whatever your objectives are, <br /> we're here to support you!{" "}
                <br />
                Click our prequalifier to begin today!
              </span>
              {/* <span className="homeHelpYouButton">
                <button
                  className="homeHelpYouButtonLeft"
                  onClick={() => setActiveChatBot("purchase")}
                >
                  Purchase
                </button>
                <button
                  className="homeHelpYouButtonRight"
                  onClick={() => setActiveChatBot("refinance")}
                >
                  Refinance
                </button>
              </span> */}
              <span className="homeHelpYouButton homeHelpYouButton01">
                <button
                  className="homeHelpYouButtonMP_Link"
                  onClick={() => setActiveChatBot("Pre-Qualify")}
                >
                  Pre-Qualify
                </button>
                <Link to="/todays-rates" className="homeHelpYouButtonMP_Link01">
                  Today’s Rates
                </Link>
              </span>
            </>
          )}

          {activeChatBot === "Pre-Qualify" && (
            <span className="homeHelpYouChatBot">
              <span className="homeHelpYouButton ChartBotBothBox">
                <span className="ChartBotForm ChartBotFormButtons">
                  <button
                    className="homeHelpYouButtonLeft"
                    onClick={() => setActiveChatBot("purchase")}
                  >
                    Purchase
                  </button>
                  <button
                    className="homeHelpYouButtonRight"
                    onClick={() => setActiveChatBot("refinance")}
                  >
                    Refinance
                  </button>
                </span>
              </span>
              <button
                className="closebtnChatBot closebtnChatBotButtons"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}

          {activeChatBot === "purchase" && (
            <span className="homeHelpYouChatBot">
              <ChatBotPurchase />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}

          {activeChatBot === "refinance" && (
            <span className="homeHelpYouChatBot">
              <ChatBotRefinance />
              <button
                className="closebtnChatBot"
                onClick={() => setActiveChatBot(null)}
              >
                X
              </button>
            </span>
          )}
        </div>
      </div>
      {/* <div className="welcomeBoxParent">
        <div className="welcomeBox">
          <span className="welcomeHeading">
            Welcome to <span className="logoBoldColor">The Mortgageist</span>.
          </span>
          <span className="welcomeContent">
            Welcome to <span className="logoBoldColor">The Mortgageist</span>,
            where expertise meets personalized service in home financing. We
            simplify mortgages, guiding you through the process with clarity and
            support. Securing the right mortgage is crucial for building lasting
            memories in your new home. We tailor our approach to each client's
            unique needs and goals, offering competitive loan options and market
            insights. Whether you're a first-time buyer or refinancing, we help
            turn your homeownership dreams into reality.
          </span>
        </div>
      </div> */}

      <div className="advantageBoxParent">
        <div className="advantageBox">
          <div className="advantageHeading">
            <span className="logoBoldColor">The Mortgageist</span> Provides
          </div>
          <div className="advantageContentBoxParent">
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={calendar}
                  alt="calender"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Quick Turnaround
              </span>
              <span className="advantageContentBoxContent">
                We stive to finalize your loan swiftly. We closed 99.9% of the
                loans in 30 days and 75% of the loans in 21 days. And do you
                have a challenging timeline? Let us know, we are here to help
                and make it happen.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneHand}
                  alt="smartphoneHand"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Exceptional Support
              </span>
              <span className="advantageContentBoxContent">
                We are ever available and eager to support. We are available on
                call, WhatsApp, SMS or email. Our team always believes that you
                should know where you are spending your hard-earned money.
              </span>
            </span>
            <span className="advantageContentBox">
              <span className="advantageContentBoxSpanImage">
                <img
                  fetchPriority="high"
                  loading="eager"
                  src={smartphoneVoice}
                  alt="smartphoneVoice"
                />
              </span>
              <span className="advantageContentBoxHeading">
                Continuous Innovation
              </span>
              <span className="advantageContentBoxContent">
                We like to make thigs easy. Loan processing need not be
                stressful. We embrace technology and always innovating and
                streamlining our processes with the most current technology.
              </span>
            </span>
          </div>
        </div>
      </div>

      <MortgageCalculator />

      <BlogPostInAPage />
    </div>
  );
}

export default Home;
